import { ErrorAlert, HeaderBar } from '../../shared';
import { Footer, Header } from '@britishcouncil/react-extro-ui';
import * as S from './GenericErrorPage.styles';
import CommonLayout from '../../shared/layout/commonLayout/CommonLayout';

export const GenericErrorPage = () => {
  return (
    <S.Root>
      <Header />
      <HeaderBar />
      <CommonLayout mainSection={<ErrorAlert />}></CommonLayout>
      <Footer />
    </S.Root>
  );
};

export default GenericErrorPage;
